export const formDefUserLogin = [
  {
    "type": "input_text",
    "params": {
      "label": "Username",
      "name": "username",
      "w": 250
    }
  },
  {
    "type": "input_password",
    "params": {
      "label": "Password",
      "name": "password",
      "w": 250
    }
  }
];

export const formDefUserRegister = [
  {
    "type": "input_text",
    "params": {
      "label": "Username",
      "name": "username",
      "w": 250
    }
  },
  {
    "type": "input_password",
    "params": {
      "label": "Password",
      "name": "password",
      "w": 250
    }
  },
  {
    "type": "input_password",
    "params": {
      "label": "Confirm password",
      "name": "confirmpassword",
      "w": 250
    }
  },
  {
    "type": "input_email",
    "params": {
      "label": "Email",
      "name": "email",
      "w": 250
    }
  },
  {
    "type": "input_email",
    "params": {
      "label": "Confirm email",
      "name": "confirmemail",
      "w": 250
    }
  },
  {
    "type": "input_text",
    "params": {
      "label": "Display name",
      "name": "display_name",
      "w": 250
    }
  },
  {
    "type": "input_text",
    "params": {
      "label": "Inicijali",
      "name": "avatar_initials",
      "w": 60
    }
  },
  {
    "type": "select",
    "params": {
      "label": "Izaberi ulogu",
      "name": "role",
      "options": [
        { "title": "USER - Korisnik regularni", "value": "USER" },
        { "title": "TESTER", "value": "TESTER" },
        { "title": "ADMIN - Administrator", "value": "ADMIN" },
        { "title": "DEV - Developer", "value": "DEV" },
        { "title": "Inzenjer", "value": "ING" },
        { "title": "Neinzenjer", "value": "NOTING" },
        { "title": "PAPIROLOG", "value": "PAPIROLOG" },
        { "title": "Gledaoc", "value": "GLEDAOC" }
      ]
    }
  },
  {
    "type": "input_checkbox",
    "params": {
      "label": "Aktiviran",
      "name": "activated"
    }
  },
  /*
  {
    "type": "textarea",
    "params": {
      "label": "Napomena",
      "name": "note"
    }
  },
  */
  {
    "type": "input_text",
    "params": {
      "label": "Napomena",
      "name": "note",
      "w": 360
    }
  },
];